// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_container {
  width: 100%;
  height: auto;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
}
.footer_container .footer_main {
  background: #18407e;
  height: 2.7rem;
  width: 100%;
}
.footer_container .footer_main .footer-image {
  width: 130px;
  display: flex;
  align-items: center;
  padding: 0rem 2rem;
}
.footer_container .footer_text {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #ffffff;
  padding: 0rem 2rem;
}
.footer_container .footer_main {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .footer_text {
    font-size: 10px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/Footer/footer.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AACF;AACE;EACE,mBAAA;EACA,cAAA;EACA,WAAA;AACJ;AACI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AACN;AAGE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AADJ;AAIE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AAFJ;;AAMA;EACE;IACE,0BAAA;EAHF;AACF","sourcesContent":[".footer_container {\n  width: 100%;\n  height: auto;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 99;\n\n  .footer_main {\n    background: #18407e;\n    height: 2.7rem;\n    width: 100%;\n\n    .footer-image {\n      width: 130px;\n      display: flex;\n      align-items: center;\n      padding: 0rem 2rem;\n    }\n  }\n\n  .footer_text {\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    color: #ffffff;\n    padding: 0rem 2rem;\n  }\n\n  .footer_main {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n}\n\n@media screen and (max-width:480px) {\n  .footer_text {\n    font-size: 10px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
